var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact"},[_c('widget-options',[(_vm.$store.getters.can( 'audit', 'updateContact' ))?_c('widget-button',{staticClass:"capitalize",attrs:{"settings":{
                action: function () { return _vm.toggleUpdateContactModal(); },
                label: 'updateContact'
            }}}):_vm._e(),(_vm.$store.getters.can( 'audit', 'resolve' ))?_c('widget-button',{staticClass:"capitalize",attrs:{"settings":{
                action: function () { return _vm.toggleModal(); },
                label: 'duplicateContactCall'
            }}}):_vm._e(),(_vm.$store.getters.can( 'audit', 'resolve' ))?_c('widget-button',{staticClass:"capitalize",attrs:{"settings":{
                action: function () { return _vm.toggleAssociateRecordingModal(); },
                label: 'associateRecording'
            }}}):_vm._e()],1),(_vm.modal.showDuplicateCall)?_c('modal',{key:_vm.modal.showDuplicateCall,attrs:{"form":{
            class: 'call__modal',
            settings: {
                typeOfPreparation: 'resolve'
            }
        },"customSettings":{
            color: 'green',
            class: 'call__modal__content',
            button: {
                label: 'confirmEvaluation'
            },
            show: {
                infoSection: false
            }
        },"executeCloseAction":!_vm.loading,"preventReset":true},on:{"close":function($event){return _vm.toggleModal()}},scopedSlots:_vm._u([{key:"modal__header",fn:function(){return [_c('h2',{staticClass:"call__modal__header"},[_vm._v(_vm._s(_vm.$t('global.callEvaluation')))])]},proxy:true},{key:"modal__body",fn:function(){return [_c('div',{staticClass:"cal__modal__body"},[_c('div',{staticClass:"call__modal__icons display--flex"},[_c('button-with-icon',{staticClass:"call__modal__icons__button",attrs:{"icon":{
                            component: function () { return import( /* webpackChunkName: 'IconPositive' */ '@/components/bundles/layout/images/icons/IconPositive' ); },
                                class: ("\n                                    call__modal__icon\n                                    call__modal__icon--green\n                                    pointer\n                                    " + (_vm.call.type === 'successful' ? 'call__modal__icon--green--active' : '') + "\n                                ")
                        },"action":{
                            execute: true,
                            function: _vm.chooseTypeOfState
                        }}}),_c('button-with-icon',{staticClass:"call__modal__icons__button",attrs:{"icon":{
                            component: function () { return import( /* webpackChunkName: 'IconReschedule' */ '@/components/bundles/layout/images/icons/IconReschedule' ); },
                            class: ("\n                                call__modal__icon\n                                call__modal__icon--reschedule\n                                pointer\n                                " + (_vm.call.type === 'rescheduling' ? 'call__modal__icon--reschedule--active' : '') + "\n                            ")
                        },"action":{
                            execute: true,
                            function: _vm.chooseTypeOfState,
                            param: 'rescheduling'
                        }}}),_c('button-with-icon',{staticClass:"call__modal__icons__button",attrs:{"icon":{
                            component: function () { return import( /* webpackChunkName: 'IconNegative' */ '@/components/bundles/layout/images/icons/IconNegative' ); },
                            class: ("\n                                call__modal__icon\n                                call__modal__icon--red\n                                pointer\n                                " + (_vm.call.type === 'unsuccessful' ? 'call__modal__icon--red--active' : '') + "\n                            ")
                        },"action":{
                            execute: true,
                            function: _vm.chooseTypeOfState,
                            param: 'unsuccessful'
                        }}})],1),(_vm.showCall.rescheduling)?_c('transition',{attrs:{"name":"call__modal--transition","appear":""}},[_c('div',{staticClass:"call__modal__rescheduling"},[_c('base-field',{staticClass:"call__modal__input",attrs:{"settings":{
                                label: { class: 'field__label--hide', text: _vm.$t('global.rescheduleTo') },
                                input: {
                                    component: 'InputCalendar',
                                    name: 'rescheduleTo',
                                    id: 'rescheduleTo',
                                    targetClass: 'field__input--default ty+pography--default color--default',
                                    value: _vm.getDateISO,
                                    browserAutocomplete: 'off',
                                    dynamicData: {
                                        configs: {
                                            mode: 'dateTime',
                                            is24hr: true,
                                            minDate: _vm.getDate,
                                            format: _vm.dateFormat,
                                            hideInput: true
                                        },
                                        isInline: true
                                    },
                                    isMissing: _vm.errors.missing.rescheduleTo,
                                    fileValidation: 'isAfterCertainDate',
                                    errors: [{
                                        type: 'isAfter', warning: _vm.$t('error.isAfter', { date: _vm.$t('global.beginDate') })
                                    }],
                                    errorOnSubmit: {
                                        show: _vm.errors.api.rescheduleTo ? true : false,
                                        messages: _vm.errors.api.rescheduleTo
                                    },
                                    validationParameter: _vm.getDate,
                                    noListener: true
                                },
                                allowFilling: true
                            }}}),_c('base-field',{staticClass:"call__modal__input call__modal__input--new-contact",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.newContact') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'newContactValue',
                                    name: 'newContactValue',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: '',
                                    browserAutocomplete: 'newContact',
                                    errorOnSubmit: {
                                        show: _vm.errors.api.newContactValue ? true : false,
                                        messages: _vm.errors.api.newContactValue
                                    },
                                    noListener: true
                                },
                                allowFilling: true
                            }}})],1)]):_vm._e(),_c('base-field',{staticClass:"call__modal__input",attrs:{"settings":{
                        label: { class: 'call__modal__label capitalize', text: _vm.$t('global.selectACause') },
                        input: {
                            component: 'InputAutocomplete',
                            id: 'stateId',
                            name: 'stateId',
                            type: 'text',
                            value: _vm.drop.value,
                            targetClass: 'field__input--default typography--default color--default',
                            browserAutocomplete: 'off',
                            isRequired: true,
                            isMissing: _vm.errors.missing.stateId,
                            dynamicData: {
                                data: _vm.call.states.drop
                            },
                            noListener: true
                        },
                        allowFilling: _vm.drop.active
                    }}})],1)]},proxy:true}],null,false,374411109)}):_vm._e(),(_vm.updateContacts.modal.show)?_c('modal',{key:_vm.updateContacts.modal.show,attrs:{"form":{
            class: 'modal--update-contact',
            settings: {
                typeOfPreparation: 'updateContacts'
                  }
        },"customSettings":{
            color: 'green',
            class: 'modal--update-contact__content',
            button: {
                label: 'confirm'
                  },
            show: {
                infoSection: false
            }
        },"executeCloseAction":!_vm.loading,"preventReset":true},on:{"close":function($event){return _vm.toggleUpdateContactModal()}},scopedSlots:_vm._u([{key:"modal__header",fn:function(){return [_c('h2',{staticClass:"modal--update-contact__header"},[_vm._v(_vm._s(_vm.$t('global.updateContact')))])]},proxy:true},{key:"modal__body",fn:function(){return [_c('div',{staticClass:"modal--update-contact__body"},[_c('base-field',{staticClass:"modal--update-contact__type",attrs:{"settings":{
                        label: { class: 'modal--update-contact__label capitalize', text: _vm.$t('global.type') },
                        input: {
                            component: 'InputAutocomplete',
                            id: 'type',
                            name: 'type',
                            type: 'text',
                            value: _vm.drop.value,
                            targetClass: 'field__input--default typography--default color--default',
                            browserAutocomplete: 'off',
                            isRequired: true,
                            isMissing: _vm.errors.missing.type,
                            dynamicData: {
                                data: _vm.updateContacts.types
                            },
                            noListener: true
                        },
                        allowFilling: true
                    }}})],1),(_vm.payload.type === 'email')?_c('base-field',{staticClass:"modal--update-contact__email",attrs:{"settings":{
                    label: { class: 'capitalize', text: _vm.$t('global.email') },
                    input: {
                        component: 'InputBasic',
                        id: 'email',
                        name: 'email',
                        type: 'text',
                        class: 'field__input--default typography--default color--default',
                        value: '',
                        browserAutocomplete: 'email',
                        isRequired: true,
                        isMissing: _vm.errors.missing.email,
                        fileValidation: 'basicEmail',
                        errors: [{
                            type: 'email', warning: _vm.$t('error.email')
                        }],
                        errorOnSubmit: {
                            show: _vm.errors.api.email ? true : false,
                            messages: _vm.errors.api.email
                        }
                    },
                    isEdition: _vm.isEdition,
                    allowFilling: true
                }}}):_vm._e(),(_vm.payload.type === 'phone')?_c('base-field',{staticClass:"modal--update-contact__phone",attrs:{"settings":{
                    label: { class: 'capitalize', text: _vm.$t('global.phone') },
                    input: {
                        component: 'InputBasic',
                        id: 'phone',
                        name: 'phone',
                        type: 'text',
                        class: 'field__input--default typography--default color--default',
                        value: '',
                        browserAutocomplete: 'phone',
                        isRequired: true,
                        isMissing: _vm.errors.missing.phone,
                        fileValidation: 'basicPhone',
                        errors: [{
                            type: 'decimal', warning: _vm.$t('error.onlyDigits')
                        }],
                        errorOnSubmit: {
                            show: _vm.errors.api.phone ? true : false,
                            messages: _vm.errors.api.phone
                        }
                    },
                    isEdition: _vm.isEdition,
                    allowFilling: true
                }}}):_vm._e()]},proxy:true}],null,false,3892986188)}):_vm._e(),(_vm.modal.associateRecording.show)?_c('modal',{key:_vm.modal.associateRecording.show,attrs:{"id":"associateModal","form":{
            class: 'call__modal',
            settings: {
                typeOfPreparation: 'associateRecordings'
            }
        },"customSettings":{
            color: 'green',
            class: 'modal--associate-recordings__content',
            button: {
                label: 'confirmAssociation'
            },
            show: {
                infoSection: false,
                actions: _vm.modal.associateRecording.type === 'recordings'
                || ( _vm.modal.associateRecording.type === 'file' && _vm.payload.hasOwnProperty('resources') )
            }
        },"executeCloseAction":!_vm.loading,"preventReset":true},on:{"close":function($event){return _vm.toggleAssociateRecordingModal()}},scopedSlots:_vm._u([{key:"modal__header",fn:function(){return [_c('h2',{staticClass:"call__modal__header"},[_vm._v(_vm._s(_vm.$t('global.associateRecording')))])]},proxy:true},{key:"modal__body",fn:function(){return [_c('div',{staticClass:"call__modal__body"},[(!_vm.modal.associateRecording.type || _vm.modal.associateRecording.type === 'file')?_c('div',{staticClass:"modal--associate-recordings__options"},[_c('div',{staticClass:"modal--associate-recordings__options__title"},[_vm._v(_vm._s(_vm.$t('global.howDoYouWantToAssociateRecording')))]),_c('div',{staticClass:"modal--associate-recordings__options__content display--flex"},[_c('base-card-option',{class:{ 'card--import-contacts__option--selected': _vm.payload.hasOwnProperty('resources') },attrs:{"templates":{ have: false }},scopedSlots:_vm._u([{key:"card__icon",fn:function(){return [_c('base-field',{staticClass:"modal--associate-recordings__options__resources",attrs:{"settings":{
                                        label: { class: 'field__label--hide' },
                                        input: {
                                            component: 'InputFile',
                                            id: 'resources',
                                            name: 'resources',
                                            type: 'file',
                                            value: '',
                                            targetClass: 'field__input--default typography--default color--default',
                                            browserAutocomplete: 'off',
                                            formatsAllowed: [ '.mp3', '.wav' ]
                                        },
                                        isEdition: false,
                                        allowFilling: true
                                    }}})]},proxy:true},{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t("global.importAudio"))+" "),_c('span',{staticClass:"typography--light"},[_vm._v("(.mp3, .wav)")])]},proxy:true}],null,false,912952694)}),_c('base-card-option',{staticClass:"pointer",nativeOn:{"click":function($event){_vm.modal.associateRecording.type = 'recordings'}},scopedSlots:_vm._u([{key:"card__icon",fn:function(){return [_c('icon-select-entities')]},proxy:true},{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t("global.selectRecording"))+" ")]},proxy:true}],null,false,3596694069)})],1)]):_vm._e(),(_vm.modal.associateRecording.type)?[_c('base-field',{staticClass:"call__modal__input associate--call",class:{ 'associate--call__file': _vm.modal.associateRecording.type === 'file' },attrs:{"settings":{
                            label: { class: 'call__modal__label capitalize', text: _vm.$t('global.call') },
                            input: {
                                component: 'InputAutocomplete',
                                id: 'call',
                                name: 'call',
                                type: 'text',
                                value: _vm.drop.value,
                                targetClass: 'field__input--default typography--default color--default',
                                browserAutocomplete: 'off',
                                isRequired: true,
                                isMissing: _vm.errors.missing.call,
                                dynamicData: {
                                    data: _vm.callsDrop
                                },
                                noListener: true
                            },
                            allowFilling: _vm.drop.active
                        }}}),(_vm.associateCall && _vm.callHasAudio( _vm.associateCall ))?_c('div',{staticClass:"call__modal__warning color--red"},[_vm._v(" "+_vm._s(_vm.$t('warning.callHasAssociatedAudio'))+" ")]):_vm._e()]:_vm._e(),(_vm.modal.associateRecording.type && _vm.modal.associateRecording.type === 'recordings')?[(_vm.associateCall)?_c('base-field',{staticClass:"call__modal__input associate--recording",attrs:{"settings":{
                            label: { class: 'call__modal__label capitalize', text: _vm.$t('global.recordingToAssociate') },
                            input: {
                                component: 'InputAutocompleteAudios',
                                id: 'recording',
                                name: 'recording',
                                type: 'text',
                                value: _vm.drop.value,
                                targetClass: 'field__input--default typography--default color--default',
                                browserAutocomplete: 'off',
                                isRequired: true,
                                isMissing: _vm.errors.missing.recording,
                                audio: _vm.audioUrl,
                                dynamicData: {
                                    data: _vm.recordingsDrop
                                },
                                noListener: true
                            },
                            allowFilling: _vm.associateCall
                        }}}):_vm._e()]:_vm._e()],2)]},proxy:true}],null,false,1982506929)}):_vm._e(),_c('base-form',{staticClass:"contact__form"},[_c('base-card',{staticClass:"contact__request",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('global.personContactDetails'))+" ")]},proxy:true},{key:"card__body",fn:function(){return [_c('div',{staticClass:"contact__body display--grid page--single__grid"},[(_vm.$route.meta.isAdd)?_c('base-field-with-url',{staticClass:"contact__body__campaign",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.campaign') },
                            input: Object.assign({}, ( !_vm.isEdition && {
                                    component: 'InputAutocomplete',
                                    id: 'campaignId',
                                    type: 'text',
                                    targetClass: 'field__input--default typography--default color--default',
                                    browserAutocomplete: 'off',
                                    isRequired: _vm.$route.meta.isAdd,
                                    isMissing: _vm.errors.missing.campaignId,
                                    dynamicData: {
                                        data: [].concat( _vm.campaigns ),
                                        ordering: _vm.order.loading
                                    },
                                    errorOnSubmit: {
                                        show: _vm.errors.api.campaignId ? true : false,
                                        messages: _vm.errors.api.campaignId
                                    }
                                }),
                                {name: 'campaignId',
                                value: _vm.campaign.name}),
                            allowFilling: !_vm.isEdition && _vm.permissions.allowFilling
                        },"anchor":{
                            url: ("/campaigns/" + _vm.campaignId),
                            disable: !_vm.campaignId,
                            see: _vm.$store.getters.can( 'campaigns', 'see' ),
                            translationKey: 'viewCampaign'
                        }}}):_vm._e(),_c('base-field',{staticClass:"contact__body__holder",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.holder') },
                            input: {
                                component: 'InputBasic',
                                id: 'holder',
                                name: 'holder',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: _vm.requestPerson.name,
                                browserAutocomplete: 'holder',
                                isRequired: _vm.$route.meta.isAdd,
                                isMissing: _vm.errors.missing.holder,
                                errorOnSubmit: {
                                    show: _vm.errors.api.holder ? true : false,
                                    messages: _vm.errors.api.holder
                                }
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: _vm.permissions.allowFilling
                        }}}),_c('base-field',{staticClass:"contact__body__contact-person",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.contactPerson') },
                            input: {
                                component: 'InputBasic',
                                id: 'contactPerson',
                                name: 'contactPerson',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: _vm.requestPerson.contactPerson,
                                browserAutocomplete: 'contactPerson',
                                isRequired: _vm.$route.meta.isAdd,
                                isMissing: _vm.errors.missing.contactPerson,
                                errorOnSubmit: {
                                    show: _vm.errors.api.contactPerson ? true : false,
                                    messages: _vm.errors.api.contactPerson
                                }
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: _vm.permissions.allowFilling
                        }}}),_c('base-field',{staticClass:"contact__body__tin",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.taxpayerIdentificationNumber') },
                            input: {
                                component: 'InputBasic',
                                id: 'taxpayerIdentificationNumber',
                                name: 'taxpayerIdentificationNumber',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: _vm.requestPerson.taxpayerIdentificationNumber,
                                browserAutocomplete: 'taxpayerIdentificationNumber',
                                isRequired: false,
                                isMissing: _vm.errors.missing.taxpayerIdentificationNumber,
                                errorOnSubmit: {
                                    show: _vm.errors.api.taxpayerIdentificationNumber ? true : false,
                                    messages: _vm.errors.api.taxpayerIdentificationNumber
                                }
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: _vm.permissions.allowFilling
                        }}}),_c('base-field',{staticClass:"contact__body__nin",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.nationalIdentificationNumber') },
                            input: {
                                component: 'InputBasic',
                                id: 'nationalIdentificationNumber',
                                name: 'nationalIdentificationNumber',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: _vm.requestPerson.nationalIdentificationNumber,
                                browserAutocomplete: 'nationalIdentificationNumber',
                                isRequired: false,
                                isMissing: _vm.errors.missing.nationalIdentificationNumber,
                                errorOnSubmit: {
                                    show: _vm.errors.api.nationalIdentificationNumber ? true : false,
                                    messages: _vm.errors.api.nationalIdentificationNumber
                                }
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: _vm.permissions.allowFilling
                        }}}),_c('base-field',{staticClass:"contact__body__birthdate",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.birthdate') },
                            input: {
                                component: 'InputCalendar',
                                id: 'birthdate',
                                name: 'birthdate',
                                targetClass: 'field__input--default typography--default color--default',
                                value: _vm.requestPerson.birthdate,
                                browserAutocomplete: 'off',
                                isRequired: false,
                                isMissing: _vm.errors.missing.birthdate,
                                errorOnSubmit: {
                                    show: _vm.errors.api.birthdate ? true : false,
                                    messages: _vm.errors.api.birthdate
                                },
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: _vm.permissions.allowFilling
                        }}}),(!_vm.isEdition)?[_c('base-field',{staticClass:"contact__body__email",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.email') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'email',
                                    name: 'email',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: '',
                                    browserAutocomplete: 'email',
                                    isRequired: false,
                                    isMissing: _vm.errors.missing.email,
                                    fileValidation: 'basicEmail',
                                    errors: [{
                                        type: 'email', warning: _vm.$t('error.email')
                                    }],
                                    errorOnSubmit: {
                                        show: _vm.errors.api.email ? true : false,
                                        messages: _vm.errors.api.email
                                    }
                                },
                                isEdition: _vm.isEdition,
                                allowFilling: true
                            }}}),_c('base-field',{staticClass:"contact__body__phone",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.phone') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'phone',
                                    name: 'phone',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: '',
                                    browserAutocomplete: 'phone',
                                    isRequired: _vm.$route.meta.isAdd,
                                    isMissing: _vm.errors.missing.phone,
                                    fileValidation: 'basicPhone',
                                    errors: [{
                                        type: 'decimal', warning: _vm.$t('error.onlyDigits')
                                    }],
                                    errorOnSubmit: {
                                        show: _vm.errors.api.phone ? true : false,
                                        messages: _vm.errors.api.phone
                                    }
                                },
                                isEdition: _vm.isEdition,
                                allowFilling: true
                            }}})]:_vm._e(),_vm._l((_vm.requestPerson.contacts),function(contact,index){return _c('div',{key:index,staticClass:"contact__body__contacts",class:{ 'contact__body__contacts__first': index === 0 }},[(_vm.requestPerson.contacts)?_c('base-field',{staticClass:"contact__body__contacts__field",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t(("contacts." + (contact.type))) },
                                input: {
                                    name: 'contactOption',
                                    class: 'field__input--default typography--default color--default',
                                    value: contact.value,
                                },
                                allowFilling: false
                            }}}):_vm._e()],1)}),(_vm.isEdition)?_c('base-field',{staticClass:"contact__body__receptiondate",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.receptionDate') },
                            input: {
                                name: 'receptionDate',
                                class: 'field__input--default typography--default color--default',
                                value: _vm.parseUtcToLocalDate({
                                    date: _vm.requestDates.receptionDate,
                                    originFormat: 'DD-MM-YYYY HH:mm',
                                    finalFormat: 'DD-MM-YYYY HH:mm'
                                }),
                            },
                            allowFilling: false
                        }}}):_vm._e(),_c('base-field',{staticClass:"contact__body__preferencecontact",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.preferenceContact') },
                            input: {
                                component: 'InputCalendar',
                                id: 'preferenceContact',
                                name: 'preferenceContact',
                                targetClass: 'field__input--default typography--default color--default',
                                value: _vm.parseUtcToLocalDate({
                                    date: _vm.requestDates.preferenceContact,
                                    originFormat: 'DD-MM-YYYY HH:mm',
                                    finalFormat: 'DD-MM-YYYY HH:mm'
                                }),
                                browserAutocomplete: 'off',
                                dynamicData: {
                                        configs: {
                                            mode: 'dateTime',
                                            is24hr: true,
                                            minDate: new Date(),
                                            format: 'YYYY-MM-DD HH:mm'
                                        },
                                        isInline: true
                                    },
                                isRequired: _vm.$route.meta.isAdd,
                                isMissing: _vm.errors.missing.preferenceContact,
                                errorOnSubmit: {
                                    show: _vm.errors.api.preferenceContact ? true : false,
                                    messages: _vm.errors.api.preferenceContact
                                },
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: _vm.permissions.allowFilling
                        }}}),_c('base-field',{staticClass:"contact__body__address",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.address') },
                            input: {
                                component: 'InputBasic',
                                id: 'address',
                                name: 'address',
                                class: 'field__input--default typography--default color--default',
                                value: _vm.requestPerson.address,
                                browserAutocomplete: 'address',
                                isRequired: false,
                                isMissing: _vm.errors.missing.address,
                                errorOnSubmit: {
                                    show: _vm.errors.api.address ? true : false,
                                    messages: _vm.errors.api.address
                                }
                            },
                            isEdition: _vm.isEdition,
                            reset: _vm.reset,
                            allowFilling: _vm.permissions.allowFilling
                        }}}),(_vm.isEdition)?_c('base-field',{staticClass:"contact__dynamic__state",attrs:{"settings":{
                            label: { class: 'capitalize', text: _vm.$t('global.state') },
                            input: {
                                component: 'States',
                                name: 'state',
                                value: _vm.stateId,
                            },
                            allowFilling: false
                        }}}):_vm._e()],2)]},proxy:true}])}),_c('base-card',{staticClass:"contact__dynamic--default page--single__space",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('global.requestDetails'))+" ")]},proxy:true},{key:"card__body",fn:function(){return [(_vm.isEdition)?_c('dynamic-fields',{staticClass:"contact__dynamic",attrs:{"obj":_vm.dataCampaignDefault}}):_c('basic-fields-list-handler',{attrs:{"groupName":"detail"}})]},proxy:true}])}),_c('base-card',{staticClass:"contact__dynamic--optional",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('global.requestOptionalDetails'))+" ")]},proxy:true},{key:"card__body",fn:function(){return [(_vm.isEdition)?_c('dynamic-fields',{staticClass:"contact__dynamic",attrs:{"obj":_vm.dataCampaignOptional}}):_c('basic-fields-list-handler',{attrs:{"groupName":"optional"}})]},proxy:true}])}),_c('base-card',{staticClass:"contact__observations page--single__space",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('global.requestObservations'))+" ")]},proxy:true},{key:"card__body",fn:function(){return [_c('base-field',{class:[
                        'contact__body__observations',
                        { 'background--grey--light': _vm.permissions.allowFilling }
                    ],attrs:{"settings":{
                        label: { class: 'field__label--hide', text: _vm.$t('global.observations') },
                        input: {
                            component: 'Textarea',
                            name: 'observations',
                            id: 'observations',
                            class: 'contact__body__observations__field typography--default color--default',
                            placeholder: _vm.$t('placeholders.observations'),
                            value: _vm.model.observations || '',
                            disableClass: 'contact__body__observations__field contact__body__observations__field--disable display--block'
                        },
                        isEdition: _vm.isEdition,
                        reset: _vm.reset,
                        allowFilling: _vm.permissions.allowFilling
                    }}})]},proxy:true}])}),(_vm.isEdition)?_c('base-card',{staticClass:"contact__calls page--single__space",attrs:{"add-margins":false},scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('global.calls'))+" ")]},proxy:true},{key:"card__body",fn:function(){return [_c('base-table',{attrs:{"headers":[
                        'id',
                        'beginDate',
                        'operator',
                        'state',
                        'audio',
                        'observations',
                        'details'
                    ],"list":_vm.calls,"model":"contact","settings":{
                        component: 'RowCalls',
                        action: _vm.showDetails,
                        warning: _vm.$t('global.calls')
                    }}})]},proxy:true}],null,false,1194539359)}):_vm._e()],1),(_vm.show)?_c('call-details',_vm._b({on:{"close":function($event){_vm.show = false}}},'call-details',{
            id: _vm.callId,
            audioUrl: _vm.audioUrl
        },false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }